"use client";

import { useEffect } from "react";
import { Toast } from "primereact/toast";
import { useToastStore } from "@/stores/toast.store";
import { useRef } from "react";

const GlobalToast = () => {
  const toastRef = useRef<Toast>(null);
  const { isVisible, severity, summary, detail, hideToast } = useToastStore();

  useEffect(() => {
    if (isVisible && toastRef.current) {
      toastRef.current.show({
        severity,
        summary,
        detail,
        life: 2000,
        style: {
          fontSize: "0.9rem",
        },
      });
      setTimeout(() => {
        hideToast();
      }, 2000);
    }
  }, [isVisible, severity, summary, detail, hideToast]);

  return (
    <Toast
      ref={toastRef}
      pt={{
        content: {
          style: {
            padding: "0.5rem 1rem",
          },
        },
        icon: {
          style: {
            width: "1.2rem",
            height: "1.2rem",
            marginTop: "0.3rem",
            marginRight: "0.5rem",
          },
        },
        text: {
          style: {
            marginLeft: "0.4rem",
          },
        },
        detail: {
          style: {
            marginTop: "0.4rem",
          },
        },
      }}
    />
  );
};

export default GlobalToast;
